import React from 'react';
import { NoDigitalSingleSchedule } from '../types';

interface NoDigitalCalendarHeaderProps {
  header: NoDigitalSingleSchedule;
}

export const NoDigitalCalendarHeader: React.FC<NoDigitalCalendarHeaderProps> = ({ header }) => {
  return (
    <thead>
      <tr>
        {header.map(({ day }, index) => (
          <th key={`header-${index}`} className="p-2 uppercase">
            {day}
          </th>
        ))}
      </tr>
    </thead>
  );
};